/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface JpClassSectionDTO
 */
export interface JpClassSectionDTOOptional {
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  sectionId?: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  sectionName?: string;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  instanceId?: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  typeName?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  startTime?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  instructorNameFirst?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  instructorNameLast?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  locationName?: string;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  enrollees?: number;
}

export interface JpClassSectionDTO extends JpClassSectionDTOOptional {
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  sectionId: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  sectionName?: string;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  instanceId: number;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  typeName: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  startDate: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  startTime: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  instructorNameFirst?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  instructorNameLast?: string;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  locationName?: string;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  enrollees: number;
}

export interface JpClassSectionDTOTrackedI {
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  sectionId?: number;
  sectionIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  sectionName?: string;
  sectionNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  startDate?: string;
  startDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  startTime?: string;
  startTimeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  instructorNameFirst?: string;
  instructorNameFirstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  instructorNameLast?: string;
  instructorNameLastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof JpClassSectionDTO
   */
  locationName?: string;
  locationNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof JpClassSectionDTO
   */
  enrollees?: number;
  enrolleesIsSet: boolean;
}

transformDatesMap.set(
  "JpClassSectionDTO",
  function (model: JpClassSectionDTO) {},
);

export type JpClassSectionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  sectionId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  sectionName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  startDate: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  startTime: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  instructorNameFirst: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  instructorNameLast: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  locationName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  enrollees: PropertyMeta<MetaTypeBase<number>>;
}>;

export var JpClassSectionDTOMeta: JpClassSectionDTOMetaI =
  {} as JpClassSectionDTOMetaI;
JpClassSectionDTOMeta = typeMeta("JpClassSectionDTO", {
  sectionId: propertyMeta(
    "sectionId",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  sectionName: propertyMeta(
    "sectionName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  instanceId: propertyMeta(
    "instanceId",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  typeName: propertyMeta("typeName", false, true, false, MetaTypesBase.string),
  startDate: propertyMeta(
    "startDate",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  startTime: propertyMeta(
    "startTime",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  instructorNameFirst: propertyMeta(
    "instructorNameFirst",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  instructorNameLast: propertyMeta(
    "instructorNameLast",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  locationName: propertyMeta(
    "locationName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  enrollees: propertyMeta(
    "enrollees",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = JpClassSectionDTOMeta;

registerMeta(() => {});

export class JpClassSectionDTOTracked implements JpClassSectionDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  sectionId__I?: number = undefined;
  sectionIdIsSet: boolean = false;
  set sectionId(v: undefined | number) {
    if (v !== undefined) {
      this.sectionId__I = v;
      this.sectionIdIsSet = true;
    } else {
      this.sectionId__I = v || undefined;
      this.sectionIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get sectionId() {
    return this.sectionId__I;
  }
  sectionName__I?: string = undefined;
  sectionNameIsSet: boolean = false;
  set sectionName(v: undefined | string) {
    if (v !== undefined) {
      this.sectionName__I = v;
      this.sectionNameIsSet = true;
    } else {
      this.sectionName__I = v || undefined;
      this.sectionNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get sectionName() {
    return this.sectionName__I;
  }
  instanceId__I?: number = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  startDate__I?: string = undefined;
  startDateIsSet: boolean = false;
  set startDate(v: undefined | string) {
    if (v !== undefined) {
      this.startDate__I = v;
      this.startDateIsSet = true;
    } else {
      this.startDate__I = v || undefined;
      this.startDateIsSet = true;
    }
    this.changeTracker = true;
  }
  get startDate() {
    return this.startDate__I;
  }
  startTime__I?: string = undefined;
  startTimeIsSet: boolean = false;
  set startTime(v: undefined | string) {
    if (v !== undefined) {
      this.startTime__I = v;
      this.startTimeIsSet = true;
    } else {
      this.startTime__I = v || undefined;
      this.startTimeIsSet = true;
    }
    this.changeTracker = true;
  }
  get startTime() {
    return this.startTime__I;
  }
  instructorNameFirst__I?: string = undefined;
  instructorNameFirstIsSet: boolean = false;
  set instructorNameFirst(v: undefined | string) {
    if (v !== undefined) {
      this.instructorNameFirst__I = v;
      this.instructorNameFirstIsSet = true;
    } else {
      this.instructorNameFirst__I = v || undefined;
      this.instructorNameFirstIsSet = false;
    }
    this.changeTracker = true;
  }
  get instructorNameFirst() {
    return this.instructorNameFirst__I;
  }
  instructorNameLast__I?: string = undefined;
  instructorNameLastIsSet: boolean = false;
  set instructorNameLast(v: undefined | string) {
    if (v !== undefined) {
      this.instructorNameLast__I = v;
      this.instructorNameLastIsSet = true;
    } else {
      this.instructorNameLast__I = v || undefined;
      this.instructorNameLastIsSet = false;
    }
    this.changeTracker = true;
  }
  get instructorNameLast() {
    return this.instructorNameLast__I;
  }
  locationName__I?: string = undefined;
  locationNameIsSet: boolean = false;
  set locationName(v: undefined | string) {
    if (v !== undefined) {
      this.locationName__I = v;
      this.locationNameIsSet = true;
    } else {
      this.locationName__I = v || undefined;
      this.locationNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get locationName() {
    return this.locationName__I;
  }
  enrollees__I?: number = undefined;
  enrolleesIsSet: boolean = false;
  set enrollees(v: undefined | number) {
    if (v !== undefined) {
      this.enrollees__I = v;
      this.enrolleesIsSet = true;
    } else {
      this.enrollees__I = v || undefined;
      this.enrolleesIsSet = true;
    }
    this.changeTracker = true;
  }
  get enrollees() {
    return this.enrollees__I;
  }
  constructor(config?: JpClassSectionDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: JpClassSectionDTOOptional,
    options?: AssignOptions,
  ): JpClassSectionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.sectionId && this.sectionIdApplyFilter(optionsRequired.filter)) {
      this.sectionId = config.sectionId;
      if (optionsRequired.unassign) this.sectionIdIsSet = false;
      else this.sectionIdIsSet = true;
    }
    if (
      config.sectionName &&
      this.sectionNameApplyFilter(optionsRequired.filter)
    ) {
      this.sectionName = config.sectionName;
      if (optionsRequired.unassign) this.sectionNameIsSet = false;
      else this.sectionNameIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (config.startDate && this.startDateApplyFilter(optionsRequired.filter)) {
      this.startDate = config.startDate;
      if (optionsRequired.unassign) this.startDateIsSet = false;
      else this.startDateIsSet = true;
    }
    if (config.startTime && this.startTimeApplyFilter(optionsRequired.filter)) {
      this.startTime = config.startTime;
      if (optionsRequired.unassign) this.startTimeIsSet = false;
      else this.startTimeIsSet = true;
    }
    if (
      config.instructorNameFirst &&
      this.instructorNameFirstApplyFilter(optionsRequired.filter)
    ) {
      this.instructorNameFirst = config.instructorNameFirst;
      if (optionsRequired.unassign) this.instructorNameFirstIsSet = false;
      else this.instructorNameFirstIsSet = true;
    }
    if (
      config.instructorNameLast &&
      this.instructorNameLastApplyFilter(optionsRequired.filter)
    ) {
      this.instructorNameLast = config.instructorNameLast;
      if (optionsRequired.unassign) this.instructorNameLastIsSet = false;
      else this.instructorNameLastIsSet = true;
    }
    if (
      config.locationName &&
      this.locationNameApplyFilter(optionsRequired.filter)
    ) {
      this.locationName = config.locationName;
      if (optionsRequired.unassign) this.locationNameIsSet = false;
      else this.locationNameIsSet = true;
    }
    if (config.enrollees && this.enrolleesApplyFilter(optionsRequired.filter)) {
      this.enrollees = config.enrollees;
      if (optionsRequired.unassign) this.enrolleesIsSet = false;
      else this.enrolleesIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): JpClassSectionDTOTrackedI {
    const cloned = {} as JpClassSectionDTOTrackedI;
    if (
      this.sectionIdIsSetDeep() &&
      this.sectionIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sectionIdIsSet = true;
      cloned.sectionId = this.sectionId;
    } else {
      //cloned.sectionIdIsSet = false
    }
    if (
      this.sectionNameIsSetDeep() &&
      this.sectionNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sectionNameIsSet = true;
      cloned.sectionName = this.sectionName;
    } else {
      //cloned.sectionNameIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.startDateIsSetDeep() &&
      this.startDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startDateIsSet = true;
      cloned.startDate = this.startDate;
    } else {
      //cloned.startDateIsSet = false
    }
    if (
      this.startTimeIsSetDeep() &&
      this.startTimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startTimeIsSet = true;
      cloned.startTime = this.startTime;
    } else {
      //cloned.startTimeIsSet = false
    }
    if (
      this.instructorNameFirstIsSetDeep() &&
      this.instructorNameFirstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instructorNameFirstIsSet = true;
      cloned.instructorNameFirst = this.instructorNameFirst;
    } else {
      //cloned.instructorNameFirstIsSet = false
    }
    if (
      this.instructorNameLastIsSetDeep() &&
      this.instructorNameLastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instructorNameLastIsSet = true;
      cloned.instructorNameLast = this.instructorNameLast;
    } else {
      //cloned.instructorNameLastIsSet = false
    }
    if (
      this.locationNameIsSetDeep() &&
      this.locationNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.locationNameIsSet = true;
      cloned.locationName = this.locationName;
    } else {
      //cloned.locationNameIsSet = false
    }
    if (
      this.enrolleesIsSetDeep() &&
      this.enrolleesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.enrolleesIsSet = true;
      cloned.enrollees = this.enrollees;
    } else {
      //cloned.enrolleesIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): JpClassSectionDTOTrackedI {
    if (!this.sectionIdApplyFilter(filter)) this.sectionIdIsSet = false;

    if (!this.sectionNameApplyFilter(filter)) this.sectionNameIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.startDateApplyFilter(filter)) this.startDateIsSet = false;

    if (!this.startTimeApplyFilter(filter)) this.startTimeIsSet = false;

    if (!this.instructorNameFirstApplyFilter(filter))
      this.instructorNameFirstIsSet = false;

    if (!this.instructorNameLastApplyFilter(filter))
      this.instructorNameLastIsSet = false;

    if (!this.locationNameApplyFilter(filter)) this.locationNameIsSet = false;

    if (!this.enrolleesApplyFilter(filter)) this.enrolleesIsSet = false;

    return this;
  }
  sectionIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.sectionId,
      JpClassSectionDTOMeta,
      this.sectionId,
      this,
    );
  }
  sectionIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sectionIdIsSet && this.sectionIdApplyFilter(filter)) return true;

    return false;
  }
  sectionNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.sectionName,
      JpClassSectionDTOMeta,
      this.sectionName,
      this,
    );
  }
  sectionNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sectionNameIsSet && this.sectionNameApplyFilter(filter))
      return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.instanceId,
      JpClassSectionDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.typeName,
      JpClassSectionDTOMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  startDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.startDate,
      JpClassSectionDTOMeta,
      this.startDate,
      this,
    );
  }
  startDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startDateIsSet && this.startDateApplyFilter(filter)) return true;

    return false;
  }
  startTimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.startTime,
      JpClassSectionDTOMeta,
      this.startTime,
      this,
    );
  }
  startTimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startTimeIsSet && this.startTimeApplyFilter(filter)) return true;

    return false;
  }
  instructorNameFirstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.instructorNameFirst,
      JpClassSectionDTOMeta,
      this.instructorNameFirst,
      this,
    );
  }
  instructorNameFirstIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.instructorNameFirstIsSet &&
      this.instructorNameFirstApplyFilter(filter)
    )
      return true;

    return false;
  }
  instructorNameLastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.instructorNameLast,
      JpClassSectionDTOMeta,
      this.instructorNameLast,
      this,
    );
  }
  instructorNameLastIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.instructorNameLastIsSet &&
      this.instructorNameLastApplyFilter(filter)
    )
      return true;

    return false;
  }
  locationNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.locationName,
      JpClassSectionDTOMeta,
      this.locationName,
      this,
    );
  }
  locationNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.locationNameIsSet && this.locationNameApplyFilter(filter))
      return true;

    return false;
  }
  enrolleesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassSectionDTOMeta.enrollees,
      JpClassSectionDTOMeta,
      this.enrollees,
      this,
    );
  }
  enrolleesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.enrolleesIsSet && this.enrolleesApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.sectionIdIsSetDeep(filter)) return true;
    if (this.sectionNameIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.startDateIsSetDeep(filter)) return true;
    if (this.startTimeIsSetDeep(filter)) return true;
    if (this.instructorNameFirstIsSetDeep(filter)) return true;
    if (this.instructorNameLastIsSetDeep(filter)) return true;
    if (this.locationNameIsSetDeep(filter)) return true;
    if (this.enrolleesIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
